import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/dashboard");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-6 p-8 max-w-md">
        <div className="mx-auto w-16 h-16 rounded-full bg-green-500/10 flex items-center justify-center">
          <Check className="w-8 h-8 text-green-500" />
        </div>
        <h1 className="text-2xl font-semibold">Payment Successful!</h1>
        <p className="text-muted-foreground">
          Your subscription is being activated. You'll be redirected to your
          dashboard in {countdown} seconds.
        </p>
        <button
          onClick={() => navigate("/dashboard")}
          className="text-sm text-primary underline hover:no-underline"
        >
          Go to dashboard now
        </button>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
